import type { IconProps } from './types';
import './icons.css';

export default function DropdownDown({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 6}
      height={height || 4}
      viewBox="0 0 6 4"
      className={`icon icon-dropdown-down ${className || ''}`}
    >
      <path
        fill="currentColor"
        d="M2.628 3.587.151.834A.5.5 0 0 1 .523 0h4.954a.5.5 0 0 1 .372.834L3.372 3.587a.5.5 0 0 1-.744 0Z"
      />
    </svg>
  );
}
